import { render, staticRenderFns } from "./sportCheck.vue?vue&type=template&id=c77c9906&scoped=true&"
import script from "./sportCheck.vue?vue&type=script&lang=js&"
export * from "./sportCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c77c9906",
  null
  
)

export default component.exports